export class Filter {
	page: number;
	type: string;
	budgetDisciplines: number[];
	credits: number[];
	endDate: string;
	evaluations: boolean;
	image: boolean;
	regions: number[];
	tagsStatewide: number[];
	search: string;
	startDate: string;
	structures: number[];
	statuses: number[];

	constructor ( data ) {
		this.page = 0;
		this.type = (data.type) ? data.type : null
		this.search = null
		this.budgetDisciplines = []
		this.credits = []
		this.endDate = null
		this.evaluations = null
		this.image = null
		this.regions = []
		this.tagsStatewide = []
		this.startDate = null
		this.statuses = []
		this.structures = []
	}
}